import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'
import { FeatureEntitlements } from './featureEntitlements'

export const brandingV2AccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: FeatureToggle.brandingV2,
  restrictedBannersAllowed: true,
}

export const storefrontHomepageDashboardV2: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.StorefrontPageBuilderView],
  featureEntitlementIds: [FeatureEntitlements.PageBuilder],
  restrictedBannersAllowed: true,
}

export const pageBuilderViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.StorefrontPageBuilderView],
  featureEntitlementIds: [FeatureEntitlements.PageBuilder],
  restrictedBannersAllowed: true,
}

export const pageBuilderModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.StorefrontPageBuilderModify],
  featureEntitlementIds: [FeatureEntitlements.PageBuilder],
  restrictedBannersAllowed: true,
}

export const marketplaceOnlyPageBuilderViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.StorefrontPageBuilderView],
  featureToggles: [FeatureToggle.pageBuilderSingleRetailer], // Feature toggle for now since internal only
  restrictedBannersAllowed: true,
}

export const marketplaceOnlyPageBuilderModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.StorefrontPageBuilderModify],
  featureToggles: [FeatureToggle.pageBuilderSingleRetailer], // Feature toggle for now since internal only
  restrictedBannersAllowed: true,
}

export const readOnlyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ReadOnly],
  restrictedBannersAllowed: true,
}

export const storeConfigurationDraftViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.StoreConfigurationDraftView],
  restrictedBannersAllowed: true,
}

export const storeConfigurationDraftModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.StoreConfigurationDraftModify],
  restrictedBannersAllowed: true,
}

export const storefrontBrandingCustomFontsControl: DomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.StorefrontBrandingCustomFonts],
  restrictedBannersAllowed: true,
}

export const storefrontBannerLogoAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.StoreConfigsView,
      Permission.StoreConfigsModify,
      Permission.StoreConfigurationDraftView,
      Permission.StoreConfigurationDraftModify,
    ],
    restrictedBannersAllowed: true,
  },
]

export const storefrontCustomImagesAccessControl: DomainAccessControlConfig = {
  // note: internal only feature for now
  permissions: [
    Permission.StoreConfigsView,
    Permission.StoreConfigsModify,
    Permission.StoreConfigurationDraftView,
    Permission.StoreConfigurationDraftModify,
  ],
}

export const slotManagerViewAccessControl: DomainAccessControlConfig = [
  {
    featureEntitlementIds: [FeatureEntitlements.PageBuilder],
    permissions: [
      Permission.StorefrontPageBuilderView,
      Permission.StoreConfigsView,
      Permission.StorefrontRetailerFundedMarketingView,
    ],
    restrictedBannersAllowed: true,
  },
  {
    permissions: [Permission.AdminPanel],
    restrictedBannersAllowed: true,
  },
]

export const slotManagerModifyAccessControl: DomainAccessControlConfig = [
  {
    featureEntitlementIds: [FeatureEntitlements.PageBuilder],
    permissions: [
      Permission.StorefrontPageBuilderModify,
      Permission.StoreConfigsModify,
      Permission.StorefrontRetailerFundedMarketingModify,
    ],
    restrictedBannersAllowed: true,
  },
  {
    permissions: [Permission.AdminPanel],
    restrictedBannersAllowed: true,
  },
]
